import styles from "./BiodataForm.module.scss";
import Icon from "../../../../assets/icons";
import BiodataFormValidation from "./BiodataFormValidation";
import primaryComponents from "../../../../components/primaryComponents";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";

const BiodataForm = ({ SignupLogic }) => {
  const [localCountryCode, setLocalCountryCode] = useState("234");
  const [countryFlag, setCountryFlag] = useState("🇳🇬");
  const {
    handleNextStep,
    email,
    lastName,
    firstName,
    phoneNumber,
    country,
    currency,
    countryCode,
    setEmail,
    setFirstName,
    setLastName,
    setPhoneNumber,
    setCountry,
    setCurrency,
    setCountryCode,
    countriesList,
    isValidatingData,
  } = SignupLogic;
  const {
    register,
    handleSubmit,
    setError,
    control,
    trigger,
    formState: { errors },
  } = BiodataFormValidation(
    email,
    firstName,
    lastName,
    phoneNumber,
    country,
    currency,
  );

  const uniqueCountriesCurrencyList = countriesList.filter(
    (obj, index, self) =>
      index === self.findIndex((t) => t.currencyName === obj.currencyName),
  );

  useEffect(() => {
    window.setError = setError;
  }, []);

  return (
    <motion.form
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0 }}
      className={styles.biodataForm}
      onSubmit={handleSubmit(handleNextStep)}
    >
      <div>
        <h3 className="mb-0 font-weight-normal">Tell us about you</h3>
        <p>Kindly provide the following details about yourself.</p>
      </div>
      <div className={styles.biodataForm__body}>
        {/* first name */}
        <div className="mt-2 mb-1">
          <primaryComponents.InputField
            control={control}
            label="First Name"
            placeholder="Enter your first Name"
            isRequired={true}
            type="text"
            name="firstName"
            value={SignupLogic?.firstName}
            errorMessage={errors.firstName}
            onChange={({ target: { value } }) => {
              setFirstName(value);
            }}
            onKeyUp={() =>
              errors.firstName !== undefined && trigger("firstName")
            }
            register={register}
          />
        </div>
        {/* last name */}
        <div className="mb-1">
          <primaryComponents.InputFieldV2
            control={control}
            label="Last Name"
            placeholder="Enter your last Name"
            isRequired={true}
            type="text"
            name="lastName"
            value={SignupLogic?.lastName}
            errorMessage={errors.lastName}
            onChange={({ target: { value } }) => {
              setLastName(value);
            }}
            onKeyUp={() => errors.lastName !== undefined && trigger("lastName")}
            register={register}
          />
        </div>
        {/* email address */}
        <div className="mb-1">
          <primaryComponents.InputFieldV2
            control={control}
            label="Email Address"
            placeholder="Enter your email address"
            isRequired={true}
            type="email"
            name="email"
            value={SignupLogic?.email}
            errorMessage={errors.email}
            onKeyUp={() => errors.email !== undefined && trigger("email")}
            onChange={({ target: { value } }) => {
              setEmail(value);
            }}
            register={register}
          />
        </div>
        {/* country */}
        <div className="mb-1">
          <Controller
            name="country"
            control={control}
            defaultValue={country}
            render={({ field: { onChange } }) => (
              <primaryComponents.SelectField
                label="Country"
                isRequired={true}
                value={country === "" ? "Select country" : country}
                onChange={(value) => {
                  const countryCode = countriesList.find(
                    (item) => item.name === value,
                  ).countryCode;
                  const flag = countriesList.find(
                    (item) => item.name === value,
                  ).countryFlag;

                  onChange(value);
                  setCountry(value);
                  setCountryCode(countryCode);
                  setLocalCountryCode(countryCode);
                  setCountryFlag(flag);
                }}
                options={countriesList}
                nameKey="name"
                idKey="name"
                errorMessage={errors.country}
              />
            )}
          />
        </div>
        {/* currency */}
        <div className="mb-1">
          <Controller
            name="currency"
            control={control}
            defaultValue={currency}
            render={({ field: { onChange } }) => (
              <primaryComponents.SelectField
                label="Trading Currency"
                isRequired={true}
                value={
                  currency === "" ? "Select your trading currency" : currency
                }
                onChange={(value) => {
                  onChange(value);
                  setCurrency(value);
                }}
                options={uniqueCountriesCurrencyList}
                nameKey="currencyNameSymbol"
                idKey="currencyCode"
                errorMessage={errors.currency}
              />
            )}
          />
        </div>
        {/* phone number */}
        <div className="mb-1">
          <primaryComponents.PhoneNumberInputFieldV2
            control={control}
            name="phoneNumber"
            label="Phone Number"
            placeholder="Enter your phone number"
            value={SignupLogic?.phoneNumber}
            errorMessage={errors.phoneNumber}
            onKeyUp={() =>
              errors.phoneNumber !== undefined && trigger("phoneNumber")
            }
            onChange={({ target: { value } }) => {
              setPhoneNumber(value);
            }}
            onChangePhoneCode={(val) => setCountryCode(val)}
            phoneCodeEditable={true}
            isRequired={true}
            register={register}
            countryCode={countryCode || localCountryCode}
            flag={countryFlag}
          />
        </div>
        <div className="d-flex justify-content-end mt-3">
          <primaryComponents.Button
            type="submit"
            classNames={"btn btn--primary"}
            isDisabled={isValidatingData}
            loadingText="Validating..."
            isLoading={isValidatingData}
          >
            <span>Next</span>
            <img className="ml-2" src={Icon.arrow_right} alt="" width="15px" />
          </primaryComponents.Button>
        </div>
      </div>
    </motion.form>
  );
};

export default BiodataForm;
